import { useEffect } from "react";
import { REBAR_CSS, REBAR_BODY } from "@/pages/rebarLandingContent";

export default function RebarLanding() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: REBAR_CSS }} />
      <div data-testid="rebar-landing" dangerouslySetInnerHTML={{ __html: REBAR_BODY }} />
    </>
  );
}
